import React, { useRef, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import useHttp from "../../../../hooks/use-http";
import convertToExcel from "../../../../components/ExportToExcel";
import Pagination from "../../../../components/Pagination";
import * as XLSX from "xlsx";
import { AutoComplete } from "antd";
import { toast } from "react-toastify";

const FarmerBudgetReport = () => {
  const frmRef = useRef({});
  const navigate = useNavigate();
  const handleButtonClick = () => {
    navigate("/farmerwise");
  };

  const formatNumber = (num) => {
    if (num === null || num === undefined) return "0.00";
    return new Intl.NumberFormat("en-NG", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(num);
  };

  const [loading, setLoading] = useState(false);

  const [employeeId, setEmployeeId] = useState();
  const [employeeData, setEmployeeData] = useState([]);

  const [seasonlist, setSeasonlist] = useState(null);
  const [seasonId, setSeasonId] = useState();

  const [ranchId, setRanchId] = useState();
  const [ranchData, setRanchData] = useState([]);
  const [fieldName, setFieldName] = useState("");
  const [fieldOptions, setFieldOptions] = useState([]);
  const [cropId, setCropId] = useState("");
  const [cropData, setCropData] = useState([]);

  const [farmerNumber, setFarmerNumber] = useState("");
  const [farmerData, setFarmerData] = useState();

  const [data, setData] = useState([]);

  const itemsPerPage = localStorage.getItem("pageSize") || 10;
  const [currentPage, setCurrentPage] = useState(1);
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;

  const currentItems = Array.isArray(data)
    ? data.slice(indexOfFirstItem, indexOfLastItem)
    : [];
  const paginate = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const [expandedGroups, setExpandedGroups] = useState({
    inputs: true,
    ppe: true,
    other: true,
  });

  // Toggle handler
  const toggleGroup = (group) => {
    setExpandedGroups((prev) => ({
      ...prev,
      [group]: !prev[group],
    }));
  };

  const { sendRequest: getEmp } = useHttp();
  const EmployeeDetail = (region) => {
    const url = `/api/fillEmployeeForReortwithCase/?useCase=Procurement&empId=${localStorage.getItem(
      "empId"
    )}&orgId=${localStorage.getItem("orgId")}${region > 0 ? `&regionId=${region}` : ""
      }`;
    getEmp({ url }, (data) => setEmployeeData(data));
  };

  useEffect(() => {
    EmployeeDetail(0);
  }, []);

  const { sendRequest: getCropData } = useHttp();

  useEffect(() => {
    getCropData(
      {
        url: `/api/farmerCropList/?orgId=${localStorage.getItem("orgId")}`,
      },
      (data) => {
        setCropData(data.output || []);
      }
    );
  }, [getCropData]);

  const { sendRequest: getSeason } = useHttp();
  useEffect(() => {
    getSeason(
      {
        url: `/api/seasons/?orgId=${localStorage.getItem("orgId")}`,
      },
      (data) => {
        setSeasonlist(data);
      }
    );
  }, [getSeason]);

  const { sendRequest: getRanch } = useHttp();
  useEffect(() => {
    getRanch(
      {
        url: `/api/ranchDetail/?orgId=${localStorage.getItem("orgId")}`,
      },
      (data) => {
        setRanchData(data);
      }
    );
  }, [getRanch]);

  const { sendRequest: getFarmerNumber } = useHttp();
  useEffect(() => {
    var url = "";
    if (employeeId > 0) {
      url = url + '&fieldExecutiveId=' + employeeId;
    }

    if (seasonId > 0) {
      url = url + '&seasonId=' + seasonId;
    }

    if (ranchId > 0) {
      url = url + '&ranchId=' + ranchId;
    }



    getFarmerNumber(
      {
        url: `/api/budgetFarmerNumberList/?orgId=${localStorage.getItem(
          "orgId"
        )}&empId=${localStorage.getItem(
          "empId"
        )}${url}`,
      },
      (data) => {
        setFarmerData(data);
      }
    );
  }, [getFarmerNumber, employeeId, ranchId, seasonId]);


  const handleSearch = (value) => {
    setFarmerNumber(value);

  };
  const filteredOptions =
    farmerData &&
    farmerData
      .filter((item) => item.farmerNo.includes(farmerNumber))
      .map((item) => ({ value: item.farmerNo }));

  const { sendRequest: getBudgetData } = useHttp();

  const fillBudgetData = (e) => {
    var urlfilter = "";

    if (employeeId > 0) {
      urlfilter = urlfilter + `&fieldExecutiveId=${employeeId}`;
    }

    if (seasonId > 0) {
      urlfilter = urlfilter + `&seasonId=${seasonId}`;
    }

    if (ranchId > 0) {
      urlfilter = urlfilter + `&ranchId=${ranchId}`;
    }
    if (fieldName && fieldName !== "") {
      urlfilter += `&fieldId=${fieldName}`;
    }
    if (farmerNumber) {
      urlfilter = urlfilter + `&farmerNo=${farmerNumber}`;
    }
    if (cropId) {
      urlfilter = urlfilter + `&cropId=${cropId}`;
    }

    var url = `/api/farmerBudgetReport/?orgId=${localStorage.getItem(
      "orgId"
    )}&empId=${localStorage.getItem("empId")}${urlfilter} `;

    getBudgetData(
      {
        url: url,
      },
      (data) => {
        console.log(data.farmerData);

        setData(data.farmerData);
      }
    );
  };

  useEffect(() => {
    fillBudgetData();
  }, [seasonId, employeeId, ranchId, fieldName, farmerNumber, cropId]);

  useEffect(() => {
    if (!data || data.length === 0) {
      setFieldOptions([]);
      return;
    }

    let filteredData = data;

    if (ranchId && ranchId > 0) {
      const selectedRanch = ranchData.find(
        (x) => String(x.ranchId) === String(ranchId)
      );

      if (selectedRanch) {
        filteredData = data.filter(
          (item) => item.ranchName === selectedRanch.ranchName
        );
      }
    }

    const uniqueFields = [
      ...new Set(
        filteredData
          .map((item) => item.fieldCode)
          .filter(Boolean)
      ),
    ];

    const fieldList = uniqueFields.map((f) => ({
      fieldCode: f,
    }));

    setFieldOptions(fieldList);
  }, [ranchId, ranchData, data]);


  const inputTypes = Array.from(
    new Set(data.flatMap((d) => (d.inputs || []).map((x) => x.poductType)))
  );
  const ppeTypes = Array.from(
    new Set(data.flatMap((d) => (d.PPE || []).map((x) => x.name)))
  );
  const otherTypes = Array.from(
    new Set(data.flatMap((d) => d.other?.map((x) => x.poductType)))
  );

  // const otherTypes = Array.from(
  //   new Set(data.flatMap((d) => (d.other || []).map((x) => x.name)))
  // );

  const handleExportExcel = () => {
    if (!data || data.length === 0) {
      toast.error("No data available to export!");
      return;
    }
    const filename = "FarmerBudgetReport.xlsx";

    const headers = [
      "Farmer No",
      "Farmer Name",
      "Crop",
      // "Field Category",

      "Ranch Name",
      "Field Code",
      "Plot No.",
      "Budget Template Name",
      "Season Name",
      "Executive Officer",
      "Plot Area",
      "Plot Size Unit",
    ];

    const inputHeaders = inputTypes.length
      ? inputTypes.map((t) => `Input - ${t}`)
      : ["Input -"];
    // const ppeHeaders = ppeTypes.length
    //   ? ppeTypes.map((t) => `PPE - ${t}`)
    //   : ["PPE -"];
    const otherHeaders = otherTypes.length
      ? otherTypes.map((t) => `Other - ${t}`)
      : ["Other -"];

    const finalHeaders = [
      ...headers,
      ...inputHeaders,
      // ...ppeHeaders,
      ...otherHeaders,
      "Total Cost",
      "Harvest Cost",
      "Profit / Loss",
    ];

    const rows = data.map((itm) => {
      const row = {
        "Farmer No": itm.farmerNo ?? "-",
        "Farmer Name": itm.farmerName ?? "-",
        Crop: itm.cropNameField ?? "-",
        // "Field Category": itm.ranchName ?? "-",

        "Ranch Name": itm.ranchName ?? "-",
        "Field Code": itm.fieldCode ?? "-",
        "Plot Name": itm.plotName ?? "-",
        "Budget Template Name": itm.farmerBudgetTemplateName ?? "-",
        "Season Name": itm.seasonName ?? "-",
        "Extension Officer": itm.executiveName ?? "-",
        "Field Size": itm.plotArea ?? "-",
        "Field Size Unit": itm.plotAreaUnit ?? "-",
      };

      const inputs = Array.isArray(itm.inputs) ? itm.inputs : [];
      // const ppes = Array.isArray(itm.PPE) ? itm.PPE : [];
      const others = Array.isArray(itm.other) ? itm.other : [];

      if (inputTypes.length > 0) {
        inputTypes.forEach((type) => {
          const item = inputs.find((x) => x.poductType === type);
          row[`Input - ${type}`] = item?.totalproductAmount ?? "-";
        });
      } else {
        row["Input -"] = "-";
      }

      // if (ppeTypes.length > 0) {
      //   ppeTypes.forEach((type) => {
      //     const item = ppes.find((x) => x.name === type);
      //     row[`PPE - ${type}`] = item?.amount ?? "-";
      //   });
      // } else {
      //   row["PPE -"] = "-";
      // }

      if (otherTypes.length > 0) {
        otherTypes.forEach((type) => {
          const item = others.find((x) => x.poductType === type);
          row[`Other - ${type}`] = item?.totalproductAmount ?? "-";
        });
      } else {
        row["Other -"] = "-";
      }

      // if (otherTypes.length > 0) {
      //   otherTypes.forEach((type) => {
      //     const item = others.find((x) => x.name === type);
      //     row[`Other - ${type}`] = item?.amount ?? "-";
      //   });
      // } else {
      //   row["Other -"] = "-";
      // }

      row["Total Cost"] = itm.totalcost ?? "-";
      row["Harvest Cost"] = itm.harvestCost ?? "-";
      row["Profit / Loss"] = itm.profitLoss ?? "-";

      return row;
    });

    const worksheet = XLSX.utils.json_to_sheet(rows);
    XLSX.utils.sheet_add_aoa(worksheet, [finalHeaders], { origin: "A1" });

    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Farmer Budget Report");
    XLSX.writeFile(workbook, filename);
  };

  return (
    <>
      <div className="content-wrapper">
        <div className="row mx-2">
          <div className="col-md-8 mt-3">
            <label className="card-title">Farmer Budget</label>
          </div>
          <div className="col-md-4 text-right mt-3">
            <button
              type="button"
              className="btn btn-tool"
              data-card-widget="remove"
              onClick={handleButtonClick}
            >
              <i className="fas fa-times" />
            </button>
          </div>
        </div>
        <br />
        <section className="content">
          <div className="container-fluid">
            <div className="row">
              <div className="col-md-3">
                <div className="form-group">
                  <label>Crop Name</label>

                  <select
                    className="form-control"
                    value={cropId}
                    onChange={(e) => setCropId(e.target.value)}
                  >
                    <option value="">Select</option>

                    {cropData &&
                      cropData.map((x) => (
                        <option key={x.CropId} value={x.CropId}>
                          {x.CropName}
                        </option>
                      ))}
                  </select>
                </div>
              </div>
              <div className="col-md-3">
                <div className="form-group">
                  <label>Season</label>
                  <select
                    id="season"
                    className="form-control"
                    value={seasonId}
                    onChange={(e) => setSeasonId(e.target.value || 0)}
                    required
                  >
                    <option value="">Select</option>
                    {seasonlist &&
                      seasonlist.map((x) => (
                        <option key={x.seasonId} value={x.seasonId}>
                          {x.seasonName}
                        </option>
                      ))}
                  </select>
                </div>
              </div>

              <div className="col-md-3">
                <div className="form-group">
                  <label>Ranch</label>
                  <select
                    id="ranch"
                    className="form-control"
                    value={ranchId}
                    onChange={(e) => {
                      setRanchId(e.target.value || 0);
                      setFieldName("");

                    }}
                  >
                    <option value="">Select</option>
                    {ranchData &&
                      ranchData.map((x) => (
                        <option key={x.ranchId} value={x.ranchId}>
                          {x.ranchName}
                        </option>
                      ))}
                  </select>
                </div>
              </div>

              <div className="col-md-3">
                <div className="form-group">
                  <label>Field Name</label>
                  <select
                    className="form-control"
                    value={fieldName}
                    onChange={(e) => {
                      setFieldName(e.target.value);
                    }}
                  >
                    <option value="">Select</option>

                    {fieldOptions.map((x, i) => (
                      <option key={i} value={x.fieldCode}>
                        {x.fieldCode}
                      </option>
                    ))}
                  </select>
                </div>
              </div>

              {/* <div className="col-md-3">
                <div className="form-group">
                  <label>Field Officer</label>
                  <select
                    id="emp_id"
                    className="form-control"
                    ref={(el) => (frmRef.current["emp_id"] = el)}
                    value={employeeId}
                    onChange={(e) => {
                      setEmployeeId(e.target.value || 0);
                      setFarmerNumber("");
                      setData([]);
                    }}
                  >
                    <option value={0}>Select</option>
                    {employeeData &&
                      employeeData.map((x) => (
                        <option
                          key={x.userId}
                          user-id={x.userId}
                          value={x.userId}
                        >
                          {x.employeeName}
                        </option>
                      ))}
                  </select>
                </div>
              </div> */}
              <div className="col-md-3">
                <label htmlFor="farmer_number">Farmer Number</label>
                <AutoComplete
                  className="form-control"
                  style={{ height: "30px" }}
                  value={farmerNumber}
                  options={filteredOptions}
                  placeholder="Farmer Number"
                  onChange={handleSearch}
                />
              </div>
              <div className="col-md-3  text-right">
                <div className="form-group">
                  <label>&nbsp;</label>
                  <button
                    className="form-control btn btn-sm btn-primary"
                    onClick={(e) => {
                      fillBudgetData();
                    }}
                  >
                    Submit
                  </button>
                </div>
              </div>
            </div>
          </div>
          <h5>Please select the parameters to get the desired result</h5>
          <hr />
        </section>

        <section className="content">
          <div className="container-fluid">
            <div className="text-right my-2">
              <button
                type="button"
                className="btn btn-sm btn-warning"
                onClick={handleExportExcel}
              >
                <i className="fas fa-file-excel"></i>
              </button>
            </div>

            <div className="row">
              <div className="col-md-12">
                <div className="card">
                  <div
                    className="card-body"
                    style={{
                      padding: "0.4rem",
                      maxHeight: "500px",
                      overflowY: "auto",
                      overflowX: "auto",
                    }}
                  >
                    <table
                      className="table table-bordered text-center table-sm"
                      style={{
                        width: "100%",
                        borderCollapse: "collapse",
                        minWidth: "1200px",
                      }}
                    >
                      <thead>
                        {/* Row 1: Main Group Headers */}
                        <tr
                          className="table-header tableheaderrowview"
                          style={{
                            // position: "sticky",
                            top: 0,
                            zIndex: 3,
                            background: "#f8f9fa",
                          }}
                        >
                          <th colSpan={10}>Farmer Details</th>

                          <th
                            colSpan={
                              expandedGroups.inputs ? inputTypes.length || 1 : 1
                            }
                            onClick={() => toggleGroup("inputs")}
                            style={{ cursor: "pointer" }}
                          >
                            Inputs {expandedGroups.inputs ? "–" : "+"}
                          </th>

                          <th
                            colSpan={
                              expandedGroups.other ? otherTypes.length || 1 : 1
                            }
                            onClick={() => toggleGroup("other")}
                            style={{ cursor: "pointer" }}
                          >
                            Other Services {expandedGroups.other ? "–" : "+"}
                          </th>

                          <th rowSpan={2}>Total Cost</th>
                          <th rowSpan={2}>Harvest Cost</th>
                          <th rowSpan={2}>Profit / Loss</th>
                        </tr>

                        {/* Row 2: Sub-Headers */}
                        <tr
                          className="table-subheader"
                          style={{
                            // position: "sticky",
                            top: "34px", // adjust this depending on row height of first header
                            zIndex: 2,
                            background: "#f8f9fa",
                          }}
                        >
                          <th>Farmer No</th>
                          <th>Farmer Name</th>
                          <th>Crop</th>
                          <th>Field Name</th>
                          <th>Plot No.</th>
                          <th>Budget Template Name</th>
                          <th>Season Name</th>
                          <th>Executive Officer</th>
                          <th>Plot Area</th>
                          <th>Plot Size Unit</th>

                          {/* Inputs */}
                          {expandedGroups.inputs ? (
                            inputTypes.length > 0 ? (
                              inputTypes.map((type, idx) => (
                                <th key={`input-head-${idx}`}>{type}</th>
                              ))
                            ) : (
                              <th>-</th>
                            )
                          ) : (
                            <th></th>
                          )}

                          {/* Other */}
                          {expandedGroups.other ? (
                            otherTypes.length > 0 ? (
                              otherTypes.map((type, idx) => (
                                <th key={`other-head-${idx}`}>{type}</th>
                              ))
                            ) : (
                              <th>-</th>
                            )
                          ) : (
                            <th></th>
                          )}
                        </tr>
                      </thead>

                      <tbody>
                        {data.map((itm, idx) => {
                          const others = Array.isArray(itm.other)
                            ? itm.other
                            : [];
                          return (
                            <tr
                              key={idx}
                              className={
                                idx % 2 === 0
                                  ? "table-row-even"
                                  : "table-row-odd"
                              }
                            >
                              <td>{itm.farmerNo || "-"}</td>
                              <td>{itm.farmerName || "-"}</td>
                              <td>{itm.cropNameField || "-"}</td>
                              <td>{itm.fieldCode || "-"}</td>
                              <td>{itm.plotName || "-"}</td>
                              <td>{itm.farmerBudgetTemplateName || "-"}</td>
                              <td>{itm.seasonName || "-"}</td>
                              <td>{itm.executiveName || "-"}</td>
                              <td>{itm.plotArea ?? "-"}</td>
                              <td>{itm.plotAreaUnit || "-"}</td>

                              {/* Inputs */}
                              {expandedGroups.inputs ? (
                                inputTypes.length > 0 ? (
                                  inputTypes.map((type, i) => {
                                    const item = itm.inputs?.find(
                                      (x) => x.poductType === type
                                    );
                                    return (
                                      <td key={`input-${idx}-${i}`}>
                                        {item?.totalproductAmount != null
                                          ? formatNumber(
                                            item.totalproductAmount
                                          )
                                          : "-"}
                                      </td>
                                    );
                                  })
                                ) : (
                                  <td>-</td>
                                )
                              ) : (
                                <td>-</td>
                              )}

                              {/* Other */}
                              {expandedGroups.other ? (
                                otherTypes.length > 0 ? (
                                  otherTypes.map((type, i) => {
                                    const item = others.find(
                                      (x) => x.poductType === type
                                    );
                                    return (
                                      <td key={`other-${idx}-${i}`}>
                                        {item?.totalproductAmount != null
                                          ? formatNumber(
                                            item.totalproductAmount
                                          )
                                          : "-"}
                                      </td>
                                    );
                                  })
                                ) : (
                                  <td>-</td>
                                )
                              ) : (
                                <td>-</td>
                              )}

                              {/* Totals */}
                              <td>
                                {itm.totalcost != null
                                  ? formatNumber(itm.totalcost)
                                  : "-"}
                              </td>
                              <td>
                                {itm.harvestCost != null
                                  ? formatNumber(itm.harvestCost)
                                  : "-"}
                              </td>
                              <td>
                                {itm.profitLoss != null
                                  ? formatNumber(itm.profitLoss)
                                  : "-"}
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  </div>

                  <div className="card-footer clearfix">
                    <Pagination
                      totalItems={data.length}
                      itemsPerPage={itemsPerPage}
                      onPageChange={paginate}
                      currentPage={currentPage}
                      setCurrentPage={setCurrentPage}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default FarmerBudgetReport;
